export default "__VITE_ASSET__a20c0825__"